import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import InputFeedback from './InputFeedback';

/** This is the "Class" used in several places that provides a title and combobox */
const SelectInput = ({
  field,
  form: { touched, errors },
  label,
  options,
  isLoading,
  className,
  changeEnhancer,
  ...props
}) => {
  const { name } = field;
  const error = touched[name] && errors[name];

  const classes = classnames('input-group field', { error: !!error }, className);
  const inputClasses = classnames('select-input', { 'is-danger': !!error });

  const enhancedOnChange = changeEnhancer
    ? (e) => {
      field.onChange(e);
      changeEnhancer(e);
    }
    : field.onChange;

  return (
    <div className={classes}>
      <label className="select-title label" htmlFor={name}>
        {label}
      </label>

      <div className={`select ${isLoading && 'is-loading'}`}>
        <select
          className={inputClasses}
          name={name}
          id={name}
          {...field}
          {...props}
          onChange={enhancedOnChange}
        >
          <option />
          {options.map(o => (
            <option value={o.value} key={o.value}>
              {o.label}
            </option>
          ))}
        </select>
      </div>

      <InputFeedback error={error} />
    </div>
  );
};

SelectInput.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string,
  }).isRequired,
  form: PropTypes.shape({
    touched: PropTypes.object,
    errors: PropTypes.object,
  }).isRequired,
  label: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
  isLoading: PropTypes.bool,
  className: PropTypes.string,
  changeEnhancer: PropTypes.func,
};

SelectInput.defaultProps = {
  label: '',
  isLoading: false,
  className: '',
  changeEnhancer: null,
};

export default SelectInput;



// WEBPACK FOOTER //
// ./src/components/common/form/SelectInput.jsx